import { render, staticRenderFns } from "./SalesOrderHistoryCard.vue?vue&type=template&id=11151cc0&scoped=true&"
import script from "./SalesOrderHistoryCard.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderHistoryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11151cc0",
  null
  
)

export default component.exports